import { FileText } from 'lucide-react';
import { memo } from 'react';
import type { DecisionItemProps } from './types';

/**
 * Decision item component for the sidebar list
 */
const DecisionItem = memo(
  ({ decision, isSelected, onSelect }: DecisionItemProps) => {
    // Extract date from case file number if present
    const formatDecisionDate = (caseFileNumber: string) => {
      const dateMatch = caseFileNumber.match(/\d{1,2}\.\d{1,2}\.\d{4}/);
      return dateMatch ? dateMatch[0] : '';
    };

    const court =
      decision.additional_data?.courts?.[0]?.name || 'Unknown Court';
    const date = formatDecisionDate(decision.case_file_number);

    return (
      <button
        className={`w-full text-left px-4 py-3 hover:bg-surface-elevated transition-colors ${
          isSelected ? 'bg-surface-selected border-l-4 border-status-info' : ''
        }`}
        onClick={() => onSelect(decision)}
        aria-selected={isSelected}
      >
        <div className='flex items-start'>
          <FileText className='w-5 h-5 text-content-muted mt-1 mr-2 flex-shrink-0' />
          <div>
            <div className='font-medium text-sm'>
              {decision.case_file_number}
            </div>
            <div className='text-xs text-content-muted mt-1'>{court}</div>
            {date && (
              <div className='text-xs text-content-muted mt-1'>{date}</div>
            )}
          </div>
        </div>
      </button>
    );
  }
);

DecisionItem.displayName = 'DecisionItem';

export default DecisionItem;
